<template>
  <el-container id="timingTjcfSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:left;align-items:center;margin-left:40px">
            <span style="width:100px; margin-left:10px; color: #000000; font-size: 13px">
               例外时段名称：
            </span>
          <el-input
              placeholder="请输入例外时段名称"
              style="width:15vw;"
              clearable
              v-model="TimingName">
          </el-input>
        </div>
        <!--        <div-->
        <!--          style="display:flex;justify-content:left;align-items:center;margin-top:25px;margin-bottom:25px;margin-left:40px">-->
        <!--          <span style="width:100px;margin-left:10px; color: #000000; font-size: 13px">-->
        <!--            约束类型：-->
        <!--          </span>-->
        <!--          <el-radio-group v-model="xz_type">-->
        <!--            <el-radio :label=1>设备状态</el-radio>-->
        <!--            <el-radio :label=2>生效时段</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </div>-->
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size: 13px">
            选择设备：
          </span>
          <el-select v-model="edi_buildId" ref='select1' @change="getFloor('build')"
                     @visible-change='show_change1'
                     clearable filterable placeholder="楼栋"
                     style="width:5vw;">
            <el-option
                v-for="item in li_build"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_floorId" ref='select2' @change="getFloor('floor')"
                     @visible-change='show_change2'
                     clearable filterable placeholder="楼层"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_floor"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_roomId" ref='select3'
                     @visible-change='show_change3'
                     clearable filterable placeholder="房间"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_room"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:150px">
          <el-select v-model="edi_dev" ref='select' @change="change_dev"
                     clearable filterable placeholder="请选择设备"
                     style="width:15vw;">
            <el-option
                v-for="item in fil_tabData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size:13px">
            选择状态：
          </span>
          <el-select v-model="edi_arg" ref='select'
                     clearable filterable placeholder="选择功能"
                     style="width:7vw;">
            <el-option
                v-for="item in li_arg"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_val" ref='select'
                     clearable filterable placeholder="选择值"
                     style="width:7vw;margin-left:15px">
            <el-option
                v-for="item in li_val"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="xz_type===2"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size:13px">
            生效时段：
          </span>
          <el-time-select
              style="width:7vw;"
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '24:00'
              }">
          </el-time-select>
          <el-time-select
              style="margin-left:15px;width:7vw;"
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '24:00',
                minTime: startTime
              }">
          </el-time-select>
        </div>
        <div>
          <div style="display:flex;justify-content:left;align-items:center;margin-top:50px;margin-left:150px">
            <el-button @click="onBack" size="medium">取消</el-button>
            <el-button @click="onKeep" size="medium" type="primary">保存</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {
  name:"timingTjcfSon",
  data() {
    return {
      is_ble:false,
      h_text:"新增例外时段",
      li_h_text:[
        {"text":"联动策略","colour":"#B7B7B7","pages":""},
        {"text":"例外时段","colour":"#B7B7B7","pages":""}
      ],
      isCtr:true,
      startTime:"",
      endTime:"",
      times:new Date(),
      rqS:[
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "日"
      ],
      check_rqS:[
        "一",
        "二",
        "三",
        "四",
        "五"
      ],
      checkAll:false,
      isIndeterminate:false,
      id:"",
      edi_dev:"",
      li_dev:[],
      edi_arg:"",
      li_arg:[
        {
          value:'pwr',
          label:'开关'
        }
      ],
      edi_val:"",
      li_val:[
        {
          value:'1',
          label:'开启'
        },
        {
          value:'0',
          label:'关闭'
        }
      ],
      li_dev_xz:[],
      TimingName:"",
      passWd:"",
      nickName:"", /*账号*/
      li_build:[],
      edi_buildId:"",
      li_floor:[],
      edi_floorId:"",
      li_room:[],
      edi_roomId:"",
      pid:"",
      tabData:[],
      xz_type:2
    };
  },
  methods:{ /*方法存放*/
    change_dev(v) {
      console.log(v);
      let d = this.tabData.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['did'] === this.did;
      });
      if (d !== undefined) {
        this.pid = d['pid'];
      }
      console.log(this.pid);
    },
    addDev() {
      if (this.li_dev_xz.length > 0) {
        this.li_dev_xz.push({
          id:this.li_dev_xz[this.li_dev_xz.length - 1]["id"] + 1,
          edi_dev:""
        });
      } else {
        this.li_dev_xz.push({
          id:0,
          edi_dev:""
        });
      }
    },
    del_dev(id) {
      const index = this.li_dev_xz.findIndex(item => item.id === id);
      this.li_dev_xz.splice(index,1);
    },
    checksChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.rqS.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
    },
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item) {
      if (item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    onKeep() {
      if (!(this.startTime && this.endTime)) {
        this.$message.warning("请先选择生效时段");
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增例外时段') {
          if (this.xz_type === 1) {
            this.addTiming1();
          } else {
            this.addTiming2();
          }
        } else {
          this.changeTiming();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    addTiming1() {
      const params = {
        'name':this.TimingName,
        'did':this.edi_dev,
        'pid':this.pid,
        'identifier':this.edi_arg,
        'interval':this.edi_val,
        'valueType':0,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addAutoCondition,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(- 1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    addTiming2() {
      console.log(this.startTime);
      const parts = this.startTime.split(':');
      const parts1 = this.endTime.split(':');
      const params = {
        'name':this.TimingName,
        'fromTime':Number(parts[0]) * 60 * 60 + Number(parts[1]) * 60,
        'toTime':Number(parts1[0]) * 60 * 60 + Number(parts1[1]) * 60,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addAutoException,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(- 1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    changeTiming() {
      console.log(this.id);
      const parts = this.startTime.split(':');
      const parts1 = this.endTime.split(':');
      const params = {
        'id':this.id,
        'name':this.TimingName,
        'fromTime':Number(parts[0]) * 60 * 60 + Number(parts[1]) * 60,
        'toTime':Number(parts1[0]) * 60 * 60 + Number(parts1[1]) * 60,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateAutoException,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(- 1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      this.$router.go(- 1);
    },
    //initArea(area_type = "") {
    //  if (area_type === 'build') {
    //    this.edi_floorId = "";
    //    this.edi_roomId = "";
    //  } else if (area_type === 'floor') {
    //    this.edi_roomId = "";
    //  }
    //  let l_d = this.li_area;
    //  let l = [];
    //  for (let i = 0; i < l_d.length; i ++) {
    //    let d = {
    //      value:l_d[i]['id'],
    //      label:l_d[i]['name']
    //    };
    //    l.push(d);
    //  }
    //  this.li_build = l;
    //  l = [];
    //  for (let i = 0; i < l_d.length; i ++) {
    //    if (this.edi_buildId && l_d[i]['id'] !== this.edi_buildId) {
    //      continue;
    //    }
    //    for (let j = 0; j < l_d[i]['floors'].length; j ++) {
    //      let d = {
    //        value:l_d[i]['floors'][j]['id'],
    //        label:l_d[i]['floors'][j]['name']
    //      };
    //      l.push(d);
    //    }
    //  }
    //  this.li_floor = l;
    //  l = [];
    //  for (let i = 0; i < l_d.length; i ++) {
    //    if (this.edi_buildId && l_d[i]['id'] !== this.edi_buildId) {
    //      continue;
    //    }
    //    for (let j = 0; j < l_d[i]['floors'].length; j ++) {
    //      if (this.edi_floorId && l_d[i]['floors'][j]['id'] !== this.edi_floorId) {
    //        continue;
    //      }
    //      for (let k = 0; k < l_d[i]['floors'][j]['rooms'].length; k ++) {
    //        let d = {
    //          value:l_d[i]['floors'][j]['rooms'][k]['id'],
    //          label:l_d[i]['floors'][j]['rooms'][k]['name']
    //        };
    //        l.push(d);
    //      }
    //    }
    //  }
    //  this.li_room = l;
    //},
    getToTime(secs) {
      let hours = Math.floor(secs / (60 * 60));
      let divisor_for_minutes = secs % (60 * 60);
      let minutes = Math.floor(divisor_for_minutes / 60);
      let divisor_for_seconds = divisor_for_minutes % 60;
      let seconds = Math.floor(divisor_for_seconds);
      let hoursString = hours < 10 ? "0" + hours:hours.toString();
      let minutesString = minutes < 10 ? "0" + minutes:minutes.toString();
      let secondsString = seconds < 10 ? "0" + seconds:seconds.toString();
      return hoursString + ":" + minutesString;
    },
    initView(area_type = "") {
      let l = [];
      let isCleanF = true;
      let isCleanR = true;
      let l_d = this.li_buildInfo;
      for (let i = 0; i < l_d.length; i ++) {
        let d = {
          value:l_d[i]['id'],
          label:l_d[i]['name']
        };
        if (this.edi_floorId === l_d[i]['id']) {
          isCleanF = false;
        }
        l.push(d);
      }
      this.li_floor = l;
      l = [];
      for (let j = 0; j < l_d.length; j ++) {
        if (this.edi_floorId && l_d[j]['id'] !== this.edi_floorId) {
          continue;
        }
        for (let k = 0; k < l_d[j]['rooms'].length; k ++) {
          let d = {
            value:l_d[j]['rooms'][k]['id'],
            label:l_d[j]['rooms'][k]['name']
          };
          if (this.edi_roomId === l_d[j]['rooms'][k]['id']) {
            isCleanR = false;
          }
          l.push(d);
        }
      }
      this.li_room = l;
      if (isCleanF) {
        this.edi_floorId = "";
      }
      if (isCleanR) {
        this.edi_roomId = "";
      }
    },
    getFloor(area_type = "") {
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.li_area[this.item]['id'],
        "projectId":localStorage.getItem("projectId")
      };
      if (area_type === "build") {
        if (this.edi_buildId) {
          params["id"] = this.edi_buildId;
          const headers = {
            'token':localStorage.getItem("token")
          };
          this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
            console.log("楼层：",res.data.data);
            this.li_buildInfo = res.data.data["floors"];
            this.initView(area_type);
          }).catch(error => {
            console.log(error);
            if (error) {
              this.$message.error("获取楼层数据失败");
            }
          });
        }
      } else if (area_type === "floor") {
        this.initView(area_type);
      }
    },
    getBuilding() {
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_area = res.data.data.list;
        let l_d = this.li_area;
        let l = [];
        for (let i = 0; i < l_d.length; i ++) {
          let d = {
            value:l_d[i]['id'],
            label:l_d[i]['name']
          };
          l.push(d);
        }
        this.li_build = l;
        this.item = 0;
        this.getFloor("build");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取区域失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(value);
    if (value === "add") {
      this.h_text = "新增例外时段";
    } else {
      this.h_text = "修改例外时段";
      this.id = parseInt(this.$route.query.id);
      this.TimingName = this.$route.query.name;
      this.fromTime = this.$route.query.fromTime;
      this.toTime = this.$route.query.toTime;
      this.startTime = this.getToTime(this.fromTime);
      this.endTime = this.getToTime(this.toTime);
    }
    this.getBuilding();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.edi_buildId && item.buildId !== this.edi_buildId) {
          this.state = false;
        }
        if (this.edi_floorId && item.floorId !== this.edi_floorId) {
          this.state = false;
        }
        if (this.edi_roomId && item.roomId !== this.edi_roomId) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#timingTjcfSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/tlinkTjtimeSon.vue